import { Button, Form, Input, Space } from "antd";
import { useEffect } from "react";
import { useAppDispatch } from "../../../../app/store";
import LockIcon from "../../../../assets/icons/LockIcon";
import { useChangePasswordMutation } from "../../../../features/auth/authApi";
import { userLoggedOut } from "../../../../features/auth/authSlice";
import useError from "../../../../hooks/useError";
import { toast } from "../../../../lib/toast";

export default function ProfileChangePassword() {
  const dispatch = useAppDispatch();
  const [changePassword, { isLoading, isSuccess, isError, error }] =
    useChangePasswordMutation();

  useError(isError, error, "Password change fail, please try again");

  const onFinish = (values: any) => {
    const { confirmPassword, ...rest } = values;

    changePassword({ ...rest });
  };

  useEffect(() => {
    if (isSuccess) {
      toast("success", "Password change successfully, please signin");
      dispatch(userLoggedOut());
    }
  }, [dispatch, isSuccess]);

  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-body text-xl font-semibold leading-normal">
          Change Password
        </h2>
      </div>

      <div>
        <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          onFinish={onFinish}
          // form={form}
        >
          <Form.Item
            name="currentPassword"
            label="Old Password"
            className="mb-4"
            rules={[
              {
                validator: (_, value) => {
                  if (!value) {
                    return Promise.reject(
                      new Error("Please enter your old password")
                    );
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input.Password prefix={<LockIcon />} placeholder="*********" />
          </Form.Item>

          <Form.Item
            name="newPassword"
            label="New Password"
            className="mb-4"
            rules={[
              {
                validator: (_, value) => {
                  if (!value) {
                    return Promise.reject(
                      new Error("Please enter your password")
                    );
                  }
                  if (value.length < 8 || value.length > 20) {
                    return Promise.reject(
                      new Error(
                        "Password length must be between 8 and 20 characters"
                      )
                    );
                  }
                  if (!/[A-Za-z]/.test(value)) {
                    return Promise.reject(
                      new Error("Password must contain at least one alphabet")
                    );
                  }
                  if (!/[0-9]/.test(value)) {
                    return Promise.reject(
                      new Error("Password must contain at least one number")
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input.Password
              prefix={<LockIcon />}
              placeholder="*********"
              // onChange={(e) =>
              //   setLoginData((prev) => ({
              //     email: prev?.email || "",
              //     password: e.target.value,
              //   }))
              // }
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="Confirm Password"
            className="mb-4"
            rules={[
              {
                required: true,
                message: "Please enter confirm password",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Password and confirm password do not match")
                  );
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockIcon />}
              placeholder="*********"
              // onChange={(e) =>
              //   setLoginData((prev) => ({
              //     email: prev?.email || "",
              //     password: e.target.value,
              //   }))
              // }
            />
          </Form.Item>

          <div className="!bg-[#FFECB5] mb-4 rounded-[4px]">
            <p className="p-2">
              For security purpose the following passwords are not supported:
            </p>
            <ul className="p-2 pt-0">
              <li className="ps-2">
                {" "}
                &#x2022; Consecutive number sequence, for example: 12345, 23456,
                24680...
              </li>
              {/* <li className="ps-2">
                &#x2022; Reverse sequence, for example: 98765, 87654, 97531...
              </li>
              <li className="ps-2">
                {" "}
                &#x2022; Same number more than three times, for example: 33333,
                64444, 11511...
              </li> */}
            </ul>
          </div>

          <Space>
            <Button
              type="primary"
              htmlType="submit"
              loading={isLoading}
              block
              className="!bg-primary "
              style={{ minWidth: 167 }}
            >
              Update Password
            </Button>
          </Space>
        </Form>
      </div>
    </>
  );
}
